export default __webpack_public_path__ + "static/media/likes.996162f3.svg";